// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
mat-form-field {
  width: 100%;
}

table {
  width: 100%;
}

.mat-header-cell, .mat-cell {
  padding: 8px 16px;
}

.mat-column-actions {
  width: 120px;
  text-align: center;
}

/* Estilo para el ícono de arrastrar */
.drag-handle {
  cursor: move;
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
}

/* Estilo para el elemento que se está arrastrando */
.cdk-drag-preview {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  background-color: white;
  border-radius: 4px;
}

/* Estilo para el placeholder mientras se arrastra */
.cdk-drag-placeholder {
  opacity: 0;
}

/* Animación al soltar el elemento */
.cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/companies/programs/programs-editor/programs-editor.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;AAEF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF;;AAEA,sCAAA;AACA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA,oDAAA;AACA;EACE,yCAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA,oDAAA;AACA;EACE,UAAA;AACF;;AAEA,oCAAA;AACA;EACE,sDAAA;AACF","sourcesContent":["mat-form-field {\n  width: 100%;\n}\n\n\ntable {\n  width: 100%; // La tabla ocupará el 100% del ancho del contenedor\n}\n\n.mat-header-cell, .mat-cell {\n  padding: 8px 16px; // Añade un poco de padding para mejorar la apariencia\n}\n\n.mat-column-actions {\n  width: 120px; // Ancho fijo para la columna de acciones\n  text-align: center; // Centrar los botones de acciones\n}\n\n/* Estilo para el ícono de arrastrar */\n.drag-handle {\n  cursor: move;\n  display: inline-flex;\n  align-items: center;\n  margin-right: 8px;\n}\n\n/* Estilo para el elemento que se está arrastrando */\n.cdk-drag-preview {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  background-color: white;\n  border-radius: 4px;\n}\n\n/* Estilo para el placeholder mientras se arrastra */\n.cdk-drag-placeholder {\n  opacity: 0;\n}\n\n/* Animación al soltar el elemento */\n.cdk-drop-list-dragging .cdk-drag {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
